var render = function render(){
  var _vm$getCampaign, _vm$simulationResults, _vm$simulationResults2, _vm$simulationResults3, _vm$simulationResults4, _vm$getDestinationInf, _vm$simulationResults5, _vm$getDestinationInf2, _vm$simulationResults6, _vm$getDestinationInf3, _vm$simulationResults7, _vm$getDestinationInf4, _vm$simulationResults8, _vm$getDestinationInf5, _vm$simulationResults9, _vm$getDestinationInf6, _vm$simulationResults10, _vm$selectedCode, _vm$selectedCode2, _vm$selectedCode2$pro, _vm$selectedCode3, _vm$selectedCode3$bra, _vm$getCampaign2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sidebar-params"
  }, [_c('div', {
    staticClass: "d-flex sidebar-params align-stretch flex-column"
  }, [_c('div', [_c('div', {
    staticClass: "simulator-title font-weight-bold mb-3"
  }, [_vm._v("Scan destination simulator")]), _c('div', {
    staticClass: "description my-3"
  }, [_vm._v("Enter the QR code Extended ID and setup scanning parameters to find out where your codes are redirecting")]), _c('v-btn', {
    staticClass: "add-code-btn my-5",
    attrs: {
      "block": "",
      "raised": ""
    },
    on: {
      "click": function ($event) {
        _vm.settingsDialog = true;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")]), _vm._v(" code and parameters ")], 1)], 1), _vm.simulationResults.elapsed_ms ? _c('div', {
    staticClass: "my-3"
  }, [_c('v-row', {
    staticClass: "ma-0 mt-3 sidebar-title",
    attrs: {
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('span', [_vm._v("QR Code")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.editSimulationParams('code');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-square-edit-outline")])], 1)], 1), _vm.selectedCode && _vm.selectedCode.message ? _c('div', {
    staticClass: "sidebar-infos"
  }, [_c('div', [_vm._v("Extended ID: " + _vm._s(_vm.selectedCode.message))]), _c('div', [_vm._v("Product: " + _vm._s(_vm.selectedCode.product.name))]), _vm.selectedCode.brand ? _c('div', [_vm._v("Brand: " + _vm._s(_vm.selectedCode.brand.name))]) : _vm._e(), _c('div', [_vm._v("Campaign: " + _vm._s((_vm$getCampaign = _vm.getCampaign(_vm.selectedCode.campaign)) === null || _vm$getCampaign === void 0 ? void 0 : _vm$getCampaign.name))]), _vm._l(_vm.filteredScmFields, function (value, key) {
    return _c('div', {
      key: `scm-${key}`
    }, [_vm._v(" " + _vm._s(key) + ": " + _vm._s(value) + " ")]);
  })], 2) : _vm._e()], 1) : _vm._e(), _vm.simulationResults.elapsed_ms ? _c('div', {
    staticClass: "my-1"
  }, [_c('v-row', {
    staticClass: "ma-0 mt-3 sidebar-title",
    attrs: {
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('span', [_vm._v("Scan parameters")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.editSimulationParams('scan');
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-square-edit-outline")])], 1)], 1), _vm._l(_vm.simulationResults.params, function (value, key) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: key !== 'code_extended_id' && _vm.isValueSet(value),
        expression: "key !== 'code_extended_id' && isValueSet(value)"
      }],
      key: `simulation-params-${key}`,
      staticClass: "pa-0 ma-2"
    }, [_c('simulation-params', {
      attrs: {
        "name": _vm.getVariableName(key),
        "type": key,
        "value": value
      }
    })], 1);
  })], 2) : _vm._e(), _vm.simulationResults.elapsed_ms ? _c('div', {
    staticClass: "my-1 mb-auto"
  }, [_c('div', {
    staticClass: "mt-6 sidebar-title"
  }, [_vm._v("Final Destination")]), _c('v-row', {
    staticClass: "mt-2 mx-0"
  }, [_vm.simulationResults.matched_rule ? _c('div', {
    staticClass: "flex-shrink-1 pill ml-2 selected"
  }, [_vm._v(_vm._s(_vm.simulationResults.matched_rule.name) + " - " + _vm._s((_vm$simulationResults = _vm.simulationResults.matched_destination) === null || _vm$simulationResults === void 0 ? void 0 : _vm$simulationResults.name))]) : _vm._e()]), _c('v-row', {
    staticClass: "mx-0"
  }, [_vm.simulationResults.is_fallback && !((_vm$simulationResults2 = _vm.simulationResults) !== null && _vm$simulationResults2 !== void 0 && (_vm$simulationResults3 = _vm$simulationResults2.matched_destination) !== null && _vm$simulationResults3 !== void 0 && _vm$simulationResults3.id) ? _c('div', {
    staticClass: "ml-2 pill selected"
  }, [_vm.simulationResults.fallback_type === 'product_url' ? _c('span', [_vm._v("Product URL")]) : _vm._e(), _vm.simulationResults.fallback_type === 'brand_url' ? _c('span', [_vm._v("Brand URL")]) : _vm._e(), _vm.simulationResults.fallback_type === 'company_url' ? _c('span', [_vm._v("Company URL")]) : _vm._e()]) : _vm.getDestinationInfos((_vm$simulationResults4 = _vm.simulationResults) === null || _vm$simulationResults4 === void 0 ? void 0 : _vm$simulationResults4.matched_destination) ? _c('div', {
    staticClass: "ml-2 pill selected",
    class: {
      'destination-warning': _vm.simulationResults.is_fallback
    }
  }, [_vm._v(" " + _vm._s((_vm$getDestinationInf = _vm.getDestinationInfos((_vm$simulationResults5 = _vm.simulationResults) === null || _vm$simulationResults5 === void 0 ? void 0 : _vm$simulationResults5.matched_destination)) === null || _vm$getDestinationInf === void 0 ? void 0 : _vm$getDestinationInf.name) + " - "), _vm.simulationResults.is_fallback ? _c('span', [_vm.simulationResults.fallback_type === 'product_url' ? _c('span', [_vm._v("Product URL")]) : _vm._e(), _vm.simulationResults.fallback_type === 'brand_url' ? _c('span', [_vm._v("Brand URL")]) : _vm._e(), _vm.simulationResults.fallback_type === 'company_url' ? _c('span', [_vm._v("Company URL")]) : _vm._e()]) : _c('span', [((_vm$getDestinationInf2 = _vm.getDestinationInfos((_vm$simulationResults6 = _vm.simulationResults) === null || _vm$simulationResults6 === void 0 ? void 0 : _vm$simulationResults6.matched_destination)) === null || _vm$getDestinationInf2 === void 0 ? void 0 : _vm$getDestinationInf2.type) == 'product' ? _c('span', [_vm._v("Product URL")]) : _vm._e(), ((_vm$getDestinationInf3 = _vm.getDestinationInfos((_vm$simulationResults7 = _vm.simulationResults) === null || _vm$simulationResults7 === void 0 ? void 0 : _vm$simulationResults7.matched_destination)) === null || _vm$getDestinationInf3 === void 0 ? void 0 : _vm$getDestinationInf3.type) == 'brand' ? _c('span', [_vm._v("Brand URL")]) : _vm._e(), ((_vm$getDestinationInf4 = _vm.getDestinationInfos((_vm$simulationResults8 = _vm.simulationResults) === null || _vm$simulationResults8 === void 0 ? void 0 : _vm$simulationResults8.matched_destination)) === null || _vm$getDestinationInf4 === void 0 ? void 0 : _vm$getDestinationInf4.type) == 'stc' ? _c('span', [_vm._v("Landing Page")]) : _vm._e(), ((_vm$getDestinationInf5 = _vm.getDestinationInfos((_vm$simulationResults9 = _vm.simulationResults) === null || _vm$simulationResults9 === void 0 ? void 0 : _vm$simulationResults9.matched_destination)) === null || _vm$getDestinationInf5 === void 0 ? void 0 : _vm$getDestinationInf5.type) == 'elabel' ? _c('span', [_vm._v("e-Label landing page")]) : _vm._e(), ((_vm$getDestinationInf6 = _vm.getDestinationInfos((_vm$simulationResults10 = _vm.simulationResults) === null || _vm$simulationResults10 === void 0 ? void 0 : _vm$simulationResults10.matched_destination)) === null || _vm$getDestinationInf6 === void 0 ? void 0 : _vm$getDestinationInf6.type) == 'url' ? _c('span', [_vm._v("Custom URL")]) : _vm._e()])]) : _vm._e()])], 1) : _vm._e(), _vm.selectedCode.message && Object.keys(_vm.simulationResults).length > 0 ? _c('div', {
    staticClass: "mt-auto mb-2"
  }, [_c('v-btn', {
    attrs: {
      "block": ""
    },
    on: {
      "click": function ($event) {
        return _vm.simulate();
      }
    }
  }, [_vm._v("simulate")])], 1) : _vm._e()]), _c('v-dialog', {
    attrs: {
      "width": "900",
      "scrollable": "",
      "persistent": true
    },
    model: {
      value: _vm.settingsDialog,
      callback: function ($$v) {
        _vm.settingsDialog = $$v;
      },
      expression: "settingsDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "grey lighten-2"
  }, [_vm._v(" Settings ")]), _c('v-card-text', {
    staticClass: "pa-0 ma-0"
  }, [_c('v-stepper', {
    staticClass: "no-shadow",
    model: {
      value: _vm.step,
      callback: function ($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-stepper-header', [_c('v-stepper-step', {
    attrs: {
      "step": "1"
    }
  }, [_vm._v("QR Code")]), _c('v-divider'), _c('v-stepper-step', {
    attrs: {
      "step": "2"
    }
  }, [_vm._v("Scan Parameters")])], 1), _c('v-stepper-items', [_c('v-stepper-content', {
    staticClass: "pa-0",
    attrs: {
      "step": "1"
    }
  }, [_c('v-form', {
    ref: "code-form",
    staticClass: "code-form pa-5",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.searchCode.apply(null, arguments);
      }
    },
    model: {
      value: _vm.codeFormValid,
      callback: function ($$v) {
        _vm.codeFormValid = $$v;
      },
      expression: "codeFormValid"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "flex-grow-1"
  }, [_c('v-text-field', {
    attrs: {
      "required": "",
      "label": "Extended ID",
      "value": _vm.selectedCode.message,
      "placeholder": "Enter a code extended ID",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1), _c('v-col', {
    staticClass: "flex-grow-0 flex-shrink-1"
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.loadingCode,
      "raised": "",
      "color": "primary"
    },
    on: {
      "click": _vm.searchCode
    }
  }, [_vm._v(" search ")])], 1)], 1), _vm.codes.length > 1 && !_vm.selectedCode.id ? _c('div', [_c('table', {
    staticClass: "codes-table"
  }, [_c('thead', [_c('td', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Extended ID")]), _c('td', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Product")])]), _c('tbody', _vm._l(_vm.codes, function (code) {
    return _c('tr', {
      key: `codes-${code.id}`,
      on: {
        "click": function ($event) {
          return _vm.selectCode(code);
        }
      }
    }, [_c('td', [_vm._v(_vm._s(code.message))]), _c('td', [_vm._v(_vm._s(code.product.name) + " - " + _vm._s(code.product.sku))])]);
  }), 0)])]) : _vm._e(), _vm.selectedCode && _vm.selectedCode.message ? _c('div', {
    staticClass: "code-infos"
  }, [_c('div', [_vm._v("Extended ID: " + _vm._s((_vm$selectedCode = _vm.selectedCode) === null || _vm$selectedCode === void 0 ? void 0 : _vm$selectedCode.message))]), _c('div', [_vm._v("Product: " + _vm._s((_vm$selectedCode2 = _vm.selectedCode) === null || _vm$selectedCode2 === void 0 ? void 0 : (_vm$selectedCode2$pro = _vm$selectedCode2.product) === null || _vm$selectedCode2$pro === void 0 ? void 0 : _vm$selectedCode2$pro.name))]), _c('div', [_vm._v("Brand: " + _vm._s((_vm$selectedCode3 = _vm.selectedCode) === null || _vm$selectedCode3 === void 0 ? void 0 : (_vm$selectedCode3$bra = _vm$selectedCode3.brand) === null || _vm$selectedCode3$bra === void 0 ? void 0 : _vm$selectedCode3$bra.name))]), _c('div', [_vm._v("Campaign: " + _vm._s((_vm$getCampaign2 = _vm.getCampaign(_vm.selectedCode.campaign)) === null || _vm$getCampaign2 === void 0 ? void 0 : _vm$getCampaign2.name))]), _vm._l(_vm.selectedCode.scm_data, function (value, key) {
    return _c('div', {
      key: `scm-${key}`
    }, [_vm._v(" " + _vm._s(key) + ": " + _vm._s(value) + " ")]);
  })], 2) : _vm._e()], 1)], 1), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-form', {
    ref: "params-form",
    staticClass: "pa-2",
    model: {
      value: _vm.paramsFormValid,
      callback: function ($$v) {
        _vm.paramsFormValid = $$v;
      },
      expression: "paramsFormValid"
    }
  }, [_c('div', [_c('div', {
    staticClass: "params-title pt-2"
  }, [_vm._v("Code Status")]), _c('div', {
    staticClass: "params-hint py-2"
  }, [_vm._v("For simulating the scan result only. This will not affect the actual code status.")]), _c('logic-value-input', {
    attrs: {
      "type": "scan_activation_status",
      "value": _vm.simulationParams[0].value,
      "operator": "is"
    },
    on: {
      "update:value": function ($event) {
        return _vm.$set(_vm.simulationParams[0], "value", $event);
      }
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "params-title pt-2"
  }, [_vm._v("Scan Location")]), _c('div', {
    staticClass: "params-hint py-2"
  }, [_vm._v("Where you expect the user to scan this code.")]), _c('logic-value-input', {
    attrs: {
      "type": "location_country_code",
      "value": _vm.simulationParams[1].value,
      "operator": "is"
    },
    on: {
      "update:value": function ($event) {
        return _vm.$set(_vm.simulationParams[1], "value", $event);
      }
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "params-title pt-2"
  }, [_vm._v("Others")]), _vm._l(_vm.simulationParams, function (param, index) {
    return _c('div', {
      key: `active-parameters-${param.key}`
    }, [param.key !== 'location_country_code' && param.key !== 'scan_activation_status' ? _c('v-row', {
      staticClass: "param my-2 mx-0"
    }, [_c('v-col', [_c('v-select', {
      staticClass: "mr-2",
      attrs: {
        "items": _vm.variables,
        "dense": "",
        "hide-details": "",
        "item-text": "description",
        "item-value": "value",
        "outlined": ""
      },
      model: {
        value: _vm.simulationParams[index].key,
        callback: function ($$v) {
          _vm.$set(_vm.simulationParams[index], "key", $$v);
        },
        expression: "simulationParams[index].key"
      }
    })], 1), _c('v-col', [_c('logic-value-input', {
      attrs: {
        "type": _vm.simulationParams[index].key,
        "value": _vm.simulationParams[index].value,
        "operator": "is"
      },
      on: {
        "update:value": function ($event) {
          return _vm.$set(_vm.simulationParams[index], "value", $event);
        }
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', {
      staticClass: "ml-2",
      attrs: {
        "color": "red",
        "icon": ""
      },
      on: {
        "click": function ($event) {
          return _vm.deleteParameter(index);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1)], 1)], 1) : _vm._e()], 1);
  })], 2), _c('v-btn', {
    staticClass: "my-4",
    on: {
      "click": function ($event) {
        return _vm.addParameter();
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-plus")]), _vm._v(" Add Parameter ")], 1)], 1)], 1)], 1)], 1)], 1), _c('v-card-actions', [_vm.step === 2 ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.step = 1;
      }
    }
  }, [_vm._v(" back ")]) : _vm._e(), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" close ")]), _vm.step === 1 ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.selectedCode.id
    },
    on: {
      "click": function ($event) {
        _vm.step = 2;
      }
    }
  }, [_vm._v(" next ")]) : _vm._e(), _vm.step === 2 ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "raised": ""
    },
    on: {
      "click": function ($event) {
        return _vm.simulate();
      }
    }
  }, [_vm._v(" simulate ")]) : _vm._e()], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }